import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,MDBBox, MDBJumbotron } from 'mdbreact';
import { Form, Input, Button, Checkbox } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import ff from '../img/9bHjJNbY.jpg';

export default class Home extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);
            this.toggle = this.toggle.bind(this);
          }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {    this.setState({value: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }



      
          handleSubmit(event) {
            // alert('A name was submitted: ' + this.state.value);
             event.preventDefault();
            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
         datafrm.append("Username", this.state.value);
         datafrm.append("Psaaword", this.state.Psaaword);

         Axios
         // .post("https://admission.kpru.ac.th/refund/api/getdata/getuseradmin", { Username: this.form.name, Password: this.form.pass })
          // .post("https://conference.kpru.ac.th/PHPAPI/select.php",datafrm)
           .post("https://edu.kpru.ac.th/conference/PHPAPI/select.php",datafrm)
           .then(res => {
             console.log("response: ", res)
             if (res.data.length !== 0) {
              // this.showitem = true;
               console.log(res)
               console.log(res.data.length)

               if (res.data[0].register_status === "1") {


                return this.setState({
                  loading: true,
                  // token_exp: +decodedEXP + "000"  //เก็บค่าหมดอายุของ token มาไว้ในตัวแปร
                }),
                  //   localStorage.setItem('tokenExp', decodedEXP + "000"),
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('iduser', res.data[0].id),

                  //   localStorage.setItem('profile', JSON.stringify(res.data[0]))
                 // window.location.href = ''
              //   window.location.href = 'https://conference.kpru.ac.th/adminconference-sd/Homeuser'
                    window.location.href = 'https://edu.kpru.ac.th/conference/Homeuser'
                 // this.props.history.replace({ pathname: 'Homeuser' })
              }
              else if (res.data[0].register_status === "2") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
    
                  // localStorage.setItem('picuser', data[0].picture);


                   window.location.href = 'https://edu.kpru.ac.th/conference/superadmin'
                 // window.location.href = '/superadmin'


                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }
              else if (res.data[0].register_status === "3") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('expert_id', res.data[0].id),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/expert'
                 // window.location.href = '/expert'


                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }  else if (res.data[0].register_status === "4") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('admin_faculty', res.data[0].register_faculty),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/adminfaculty'
                 // window.location.href = '/adminfaculty'

                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }else if (res.data[0].register_status === "5") {
                return this.setState({
                  login_error3: true,
                  // picuser: data.picture,
                }),
    
                  localStorage.setItem('nameuser', res.data[0].register_nameth + ' ' + res.data[0].register_lnameth),
                  localStorage.setItem('admin_type', res.data[0].register_status),
                  localStorage.setItem('expert_id', res.data[0].id),
    
                  // localStorage.setItem('picuser', data[0].picture);

                  window.location.href = 'https://edu.kpru.ac.th/conference/expertbn'
                 // window.location.href = '/adminfaculty'

                //  this.props.history.replace({ pathname: '/Reportbanner' })
              }

             }else{
              this.setState({
                modal: true
               
            })
              // window.location.href = '/'
              // window.location.href = '/'
             }
             // do something about response
           })

          }


    update = () => {
        this.setState({
            name: "",
            lname: ""
        })
    }
    

    render() {
        return (
            <div>
                <MDBContainer >
                <div className='mt-1'>
                   {/* <img src="https://conference.kpru.ac.th/Research/views/login/headercf.png" className="rounded  d-block w-200" alt="aligment"  /> */}
                    
                </div>
                 <MDBJumbotron>
                    <MDBRow >
                  
                    <MDBCol md="4">
                    </MDBCol>
                        <MDBCol md="4">
                            <div  >
                            {/* <img src="https://conference.kpru.ac.th/adminconference-sd/download/logokpru.png" className="rounded mx-auto d-block w-50" alt="aligment" /> */}
                            {/* <img src={ff} className="rounded  d-block w-50 center" alt="aligment"  /> */}
                            <br/>
                            
                        <form onSubmit={this.handleSubmit}>
                            {/* <p className="h5 text-center ">เข้าสู่ระบบ</p> */}
                            <MDBBox tag="p" className="text-center">
                            <img src={ff} className="rounded  mx-auto d-block w-50" alt="aligment"  />
                              <h4><strong>เข้าสู่ระบบ</strong></h4></MDBBox>
                            <p className="h5 text-center ">การประชุมวิชาการระดับชาติ</p>
                            <p className="h5 text-center "> ครุศาสตร์ศึกษา ครั้งที่ 8 </p>
                            <p className="h5 text-center "> วันที่ 6 กุมภาพันธ์ 2569  </p>
                            <p className="h5 text-center "> ณ มหาวิทยาลัยราชภัฏกำแพงเพชร </p>
                            <div className="grey-text">
                            <MDBInput className="text-left" label="Username" icon="user" group type="text" validate error="wrong"
                                success="right"  name="Username" value={this.state.value} onChange={this.handleChange}/>

                            <MDBInput label="Password" icon="key" group type="password" validate error="wrong"
                                success="right" value={this.state.Psaaword} onChange={this.handleChange2} />

                            </div>
                            <div className="text-center">
                            <MDBBtn outline color="info" type="submit" value="Submit" >
                             เข้าสู่ระบบ
                                <MDBIcon far icon="paper-plane" className="ml-1" />
                            </MDBBtn>
                            </div>
                        </form>
                          {/* <Login/> */}
                           {/* {this.state.value}
                           {this.state.Psaaword} */}
                        </div>
                        </MDBCol>
                        <MDBCol md="4">
                    </MDBCol>
                  
                    </MDBRow>
  </MDBJumbotron>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
        <MDBModalHeader toggle={this.toggle}>
        </MDBModalHeader>
        <MDBModalBody className="text-center">
         
        <MDBIcon icon="exclamation-circle" className="red-text text-center" size="5x" />
         <h3>usermame หรือ password ไม่ถูกต้อง</h3>
         <h3>กรุณาตรวจสอบความถูกต้อง อีกครั้ง!</h3>
        </MDBModalBody>
       
      </MDBModal>
                   
                    </MDBContainer>
                   
            </div>
        )
    }
}
